import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CanonicalUrl = () => {
    const location = useLocation();

    useEffect(() => {
        const { href } = window.location;
        const canonicalUrl = href.replace(`-stage`, ``).replace(`-develop`, ``);
        let canonical = document.querySelector(`link[rel="canonical"]`) as HTMLLinkElement | null;

        if (canonical && canonical.href !== canonicalUrl) {
            canonical.remove();
        }
        if (!canonical || canonical.href !== canonicalUrl) {
            canonical = document.createElement(`link`);
            canonical.rel = `canonical`;
            canonical.href = canonicalUrl;
            document.head.appendChild(canonical);
        }
    }, [location]);

    return null;
};

export default CanonicalUrl;
